import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BookConsultationComponent } from '../../../shared/components/book-consultation/book-consultation.component';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { CategoryService } from '../../../shared/services/category.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { SkeletonService } from '../../../shared/services/skeleton.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FaqPageComponent } from '../faq-page/faq-page.component';

@Component({
  selector: 'app-inbt-mother-category',
  standalone: true,
  imports: [CommonModule,CarousalPageComponent,FaqPageComponent,CarouselModule,RouterModule],
  templateUrl: './inbt-mother-category.component.html',
  styleUrl: './inbt-mother-category.component.scss'
})
export class InbtMotherCategoryComponent implements OnDestroy {
  environment: any = environment;
  categoryGuid: any;
  categoryData: any;
  mobileBannerList: any = [];
  webBannerList: any = [];
  productCarousalData: any;
  isSolar!: boolean;
  smallWebBannerList: any = [];
  smallMobileBannerList: any = [];
  solarSubCategory: any = [];
  sub:Subscription=new Subscription()
  bannerAreaData: any;
  bannerAreaBanners: any;
  catUrlInfo: any;
  src: any;
  process: any;
  showVideoSection: boolean = false;
  categoryName: any;
  landingPageName: any;
  autoplay: boolean=true;
script:any;
actualSchemaValue:any;
structuredData!:SafeHtml;
isFirstSlide = false;
isLastSlide = false;
  constructor(
    public utils: UtilsService,
    public dialog: MatDialog,
    public analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    private catSvc: CategoryService,
    private router: Router,
    private metaSvc: MetaMgmtService,
    private _dataLayerService: DataLayerService,
    private schemaService: SchemaService,
    public skeletonService: SkeletonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private sanitizer: DomSanitizer
  ) {
    this.utils.showHeaderFooter.next(true);
   this.sub.add( this.route.params.subscribe((params: any) => {
      // this.catUrlInfo = params['categoryName'] ? params['categoryName'] : '';
      this.resetAll();
      this.categoryGuid = params['guid'] ? params['guid'] : '';
      this.categoryName = params['categoryName'] ? params['categoryName'] : '';
      this.landingPageName = params['categoryName']
        ? params['categoryName']
        : '';
      this.categoryName = this.categoryName.replace('-', ' ');
      this.isSolar =
        params['isSolar'] && params['isSolar'] == 'solar' ? true : false;
      this.inIt();
    }));
  }

  inIt() {
    if (this.categoryGuid || this.categoryName) {
      this.utils.showLoading();
      if (this.isSolar) {
        this.sub.add(this.catSvc
          .getSolarCategoryDataByGuid(
            this.categoryGuid,
            this.landingPageName,
            this.categoryGuid ? true : false
          )
          .subscribe({
            next: (_res: any) => {
              if (_res.success) {
                this.categoryData = _res.solarCategoryLandingPageResponse;
                this.metaSvc.updateMetaTags(_res.metaInfoResponse);
                this.assignData(_res);
              } else {
                this.utils.openSnackBar(_res.message, 'error-toster');
                this.utils.backToRoot();
                this.utils.hideLoading();
              }
            },
          }));
      } else {
      this.sub.add(  this.catSvc.getCategoryDataByGuid(this.categoryGuid, this.landingPageName, this.categoryGuid ? true : false).subscribe({
          next: (res: any) => {
            if (res.success) {
    if (isPlatformBrowser(this.platformId)) {

              this.categoryData = res;
              this.triggerViewListEvent('view_item_list');
              this.metaSvc.updateMetaTags(res.metaInfoResponse);
    }
    this.assignData();

            }
            else {
              this.utils.openSnackBar(res.message, 'error-toster')
              this.utils.hideLoading();
            }
          }
        }))
      }
    } else {
      this.utils.backToRoot();
    }
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.updateAutoplay();
  }

  updateAutoplay() {
    const isBannerVisible = this.utils.isElementVisible('caraousel-scroll');
    if (!isBannerVisible) {
      this.autoplay = false;
    } else {
      this.autoplay = true;
    }
  }


  triggerBannerClick(bannerData: any) {
    this._dataLayerService.triggerPromotionEvents(bannerData, 'select_promotion');
  }



  handleSlideChange(event: any, type: string) {
    let currentSlideData: any;
    let slideList: any;
    
    if (this.autoplay) {
      if (type === 'web') {
        currentSlideData = this.webBannerList[event.startPosition];
        slideList = this.webBannerList;
      } else if (type === 'mob') {
        currentSlideData = this.mobileBannerList[event.startPosition];
        slideList = this.mobileBannerList;
      } else if (type === 'home') {
        currentSlideData = this.webBannerList?.mainBannerResponse[event.startPosition];
        slideList = this.webBannerList?.mainBannerResponse;
      }
  
      currentSlideData.creativeSlot = event.startPosition + 1;
      this.triggerPromotionEventsIfListExists([currentSlideData]);
  
      const totalSlides = slideList?.length || 0;
      const currentIndex = event.startPosition || 0;
  
      this.isFirstSlide = currentIndex === 0;
      this.isLastSlide = currentIndex === totalSlides - 1;
    }
  }
  


  triggerPromotionEventsIfListExists(bannerList: any) {
    if (bannerList && bannerList.length > 0) {
      this._dataLayerService.triggerPromotionEvents(
        bannerList,
        'view_promotion'
      );
    }
  }
  triggerViewListEvent(eventName: string) {
    const productInfo = JSON.parse(this.utils.getProductInfo());
    let itemArray = this.categoryData.inbtLandingProductList.map((data: any, index: number) => {
      return {
        item_id: data?.productSKU || '',
        item_name: data?.productName || '',
        item_brand: data.seriesName ? data.seriesName : this.categoryData.categoryName || '',
        currency: 'INR',
        discount: data?.discount || 0,
        item_category: this.categoryData.categoryName || '',
        item_category2: productInfo?.brandSubCategoriesMenus?.subCategory || '',
        item_category4: data?.vaRating || '',
        item_category5: data?.technology || '',
        price: data?.productMRP,
        item_list_name: 'Our products',
        item_list_id: 'our_products',
        item_variant: data?.warranty || ''
      };
    });
    this._dataLayerService.triggerEvents(itemArray, eventName);
  }


  assignData(response?: any) {
    if (this.categoryData && this.categoryData.bannerList) {
      this.categoryData.bannerList.forEach((element: any) => {
        let mobileBanner = {
          image: element.mobileImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.mobileImageFileName
        };
        let webBanner = {
          image: element.webImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.webImageFileName
        };
        if (!element.isSmallBanner) {
          this.webBannerList.push(webBanner);
          this.mobileBannerList.push(mobileBanner);
        } else {
          this.smallWebBannerList.push(webBanner);
          this.smallMobileBannerList.push(mobileBanner);
        }
      });
      if (this.webBannerList && this.webBannerList.length > 1) {
        this.utils.customOptionsForBanner.loop = true;
      }
      if (this.smallWebBannerList && this.smallWebBannerList.length > 1) {
        this.utils.customOptionsForSmallBanner.loop = true;
      }


    }
    this.productCarousalData = [];
    if (this.categoryData && this.categoryData.inbtLandingProductList) {
      this.categoryData.inbtLandingProductList.forEach((element: any) => {
        let obj = {
          image: element.featureImageFile,
          description: element.productName,
          price: element.productMRP ? element.productMRP : '0',
          altTag: element.featureImageAltTag,
          productGuid: element.productGuidId,
        };
        this.productCarousalData.push(obj);
      });
    }
    if (this.categoryData && this.categoryData.inbtLandingSubCategoryList) {
      const inbtFilteredObject =  this.categoryData.inbtLandingSubCategoryList.map((subCategory: any) => {
        return {
          subCategoryName: subCategory.subCategoryName
        };
      });
      this.schemaService.sendData(inbtFilteredObject);
      this.callSchema();

    }
    this.solarSubCategory =
      response &&
        response.solarSubCategoryListPageResponse &&
        response.solarSubCategoryListPageResponse.solarSubCategoryPageResponses
        ? response.solarSubCategoryListPageResponse
          .solarSubCategoryPageResponses
        : [];
    if(this.solarSubCategory) {
      const solarFilteredObject = this.solarSubCategory.map((subCategory: any) => {
        return {
          subCategoryName: subCategory.solarSubCategoryName
        };
      });
      this.schemaService.sendData(solarFilteredObject);
      this.callSchema();
      this.getMotherCategorySchema(solarFilteredObject)
    }
    this.bannerAreaData =
      response && response.solarCategoryResearchAreaResponse
        ? response.solarCategoryResearchAreaResponse
        : {};
    if (
      this.bannerAreaData &&
      this.bannerAreaData.bannerList &&
      this.bannerAreaData.bannerList.length
    ) {
      this.bannerAreaBanners = [];
      this.bannerAreaData.bannerList.forEach((element: any) => {
        let obj = {
          image: element.webImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.webImageFileName
        };
        this.bannerAreaBanners.push(obj);

      });
    }
    if (this.isSolar && response && response.commonSectionDetail) {
      this.categoryData['mediaList'] = response.commonSectionDetail.mediaList
        ? response.commonSectionDetail.mediaList
        : [];
      this.schemaService.sendData(this.categoryData['mediaList']);
      this.callSchema();

      this.categoryData['questionAnswerList'] = response.commonSectionDetail
        .questionAnswerList
        ? response.commonSectionDetail.questionAnswerList
        : [];
      this.categoryData['blogList'] = response.commonSectionDetail.blogList
        ? response.commonSectionDetail.blogList
        : [];
    }
    setTimeout(() => {
      let indexToRemove: any = [];
      if (
        this.categoryData &&
        this.categoryData.mediaList &&
        this.categoryData.mediaList.length
      ) {
        this.categoryData.mediaList.forEach((element: any, index: any) => {
          if (!this.utils.validURL(element.embededLink)) {
            indexToRemove.push(index);
          }
        });
      }
      if (indexToRemove && indexToRemove.length) {
        indexToRemove = indexToRemove.sort(function (a: any, b: any) {
          return b - a;
        });
        indexToRemove.forEach((element: any) => {
          this.categoryData.mediaList.splice(element, 1);
        });
      }
      this.showVideoSection =
        this.categoryData &&
          this.categoryData.mediaList &&
          this.categoryData.mediaList.length
          ? true
          : false;
    }, 200);
    this.utils.hideLoading();
  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = JSON.stringify(this.actualSchemaValue);
    this._renderer2.appendChild(this._document.body, this.script);

  }
  resetAll() {
    this.mobileBannerList = [];
    this.webBannerList = [];
    this.productCarousalData;
    this.isSolar = false;
    this.smallWebBannerList = [];
    this.smallMobileBannerList = [];
    this.solarSubCategory = [];
    this.bannerAreaData = {};
    this.bannerAreaBanners = [];
    this.showVideoSection = false;
  }

  getSubCatRouteLink(subCatData: any, isInbt: boolean) {
    let url = '';
    if (isInbt) {
      let subCatTitle = this.utils.createNameForUrl(subCatData.subCategoryName);
      url = `/sub-category/${subCatTitle}`;
    } else {
      let subCatTitle = this.utils.createNameForUrl(
        subCatData.solarSubCategoryName
      );
      url = `/sub-category/${subCatTitle}`;
    }
    return url;
  }

  triggerSubcategoryClicked(subCatData: any, isInbt: boolean) {
    const data = {
      eventName: 'Sub-Category Viewed',
      eventData: {
        'Sub-Category Name': isInbt
          ? subCatData.subCategoryName
          : subCatData.solarSubCategoryName,
        'Category Name': isInbt
          ? this.categoryData.categoryName
          : this.categoryData.brandCategoryName,
      },
    };
    this.analyticsService.trackData(data);
  }

  getPlpRouteLink(subCatData: any) {
    let url = '';
    let categoryName = this.utils.createNameForUrl(
      this.categoryData.categoryName
        ? this.categoryData.categoryName
        : this.categoryData.brandCategoryName
          ? this.categoryData.brandCategoryName
          : ''
    );
    if (this.isSolar) {

      url = `/product-listing/${categoryName}/${this.utils.createNameForUrl(
        subCatData.solarSubCategoryName
      )}`;
    } else {
      url = `/product-listing/${categoryName}/${this.utils.createNameForUrl(
        subCatData.subCategoryName
      )}`;
    }
    return url;
  }

  onProductClick(data: any) {
    if (isPlatformBrowser(this.platformId)) {

    localStorage.setItem('source', 'Brand');
    this.triggerViewListEvent('select_item');

  }}

  bookConsultationModal() {
    const dialogRef = this.dialog.open(BookConsultationComponent, {
      disableClose: true,
      data: this.utils.getUserPicode(),
    });
   this.sub.add( dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
      }
    }));
  }
  ngOnDestroy(): void {
      this.sub.unsubscribe()
  }
  getMotherCategorySchema(data:any){
    let productListschemaarr:any = [];
    if(isPlatformBrowser(this.platformId)){
   
      data.forEach((ele:any,index:any) => {
        let Productname = this.utils.createNameForUrl(ele.subCategoryName ? ele.subCategoryName : '')
        let tempObj = {
          "@type": "ListItem",
          "position": index + 1,
          "name": ele.subCategoryName,
          "url": "https://www.luminousindia.com/"
        }
        productListschemaarr.push(tempObj)
      })
      let schemaobj = {
        "@context": "https://schema.org/",
        "@type": "ItemList",
        "itemListElement":productListschemaarr
      }
  
      this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
        <script type="application/ld+json">
          ${JSON.stringify(schemaobj)}
        </script>
      `);
    }else{}
  
  }
}
